import type { Episode, PodcastSummary } from './types'
import EpisodeList from './EpisodeList'

export type DetailState = {
  loading: boolean
  error?: string
  podcast?: PodcastSummary
  episodes: Episode[]
  hasMore: boolean
}

type Props = {
  state: DetailState
  selectedIds: Set<string>
  canAdd: boolean
  onAdd: (episode: Episode) => void
  onAddBatch: () => void
  onRemove: (id: string) => void
  onLoadMore: () => void
  onBack: () => void
}

export default function PodcastDetailPanel({
  state,
  selectedIds,
  canAdd,
  onAdd,
  onAddBatch,
  onRemove,
  onLoadMore,
  onBack,
}: Props) {
  if (state.error) {
    return (
      <div className="podcast-detail-panel">
        <button type="button" className="podcast-link-button" onClick={onBack}>
          &larr; Back to results
        </button>
        <p className="music-player__status music-player__status--err">{state.error}</p>
      </div>
    )
  }

  if (state.loading && !state.podcast) {
    return (
      <div className="podcast-detail-panel">
        <button type="button" className="podcast-link-button" onClick={onBack}>
          &larr; Back to results
        </button>
        <p className="podcast-loading">Loading podcast…</p>
      </div>
    )
  }

  if (!state.podcast) {
    return null
  }

  const p = state.podcast
  const hasUnselected = state.episodes.some((e) => !selectedIds.has(e.id))
  const addBatchEnabled = canAdd && hasUnselected

  return (
    <div className="podcast-detail-panel">
      <button type="button" className="podcast-link-button" onClick={onBack}>
        &larr; Back to results
      </button>
      <div className="podcast-detail-panel__header">
        {p.image && (
          <img src={p.image} alt="" className="podcast-detail-panel__image" />
        )}
        <div>
          <h2 className="podcast-detail-panel__title">{p.title}</h2>
          <p className="podcast-detail-panel__publisher">{p.publisher}</p>
          {p.description && (
            <p className="podcast-detail-panel__description">{p.description}</p>
          )}
          <button
            type="button"
            className="btn btn-primary podcast-detail-panel__add-batch"
            onClick={onAddBatch}
            disabled={!addBatchEnabled}
          >
            Add episodes
          </button>
        </div>
      </div>
      <EpisodeList
        episodes={state.episodes}
        selectedIds={selectedIds}
        canAdd={canAdd}
        loading={state.loading}
        hasMore={state.hasMore}
        onAdd={onAdd}
        onRemove={onRemove}
        onLoadMore={onLoadMore}
      />
    </div>
  )
}
